import { render, staticRenderFns } from "./felixItem.vue?vue&type=template&id=75c668bc&scoped=true"
import script from "./felixItem.vue?vue&type=script&lang=js"
export * from "./felixItem.vue?vue&type=script&lang=js"
import style0 from "./felixItem.vue?vue&type=style&index=0&id=75c668bc&prod&lang=scss&scoped=true"
import style1 from "./felixItem.vue?vue&type=style&index=1&id=75c668bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75c668bc",
  null
  
)

export default component.exports